import {
  LayoutDashboard,
  ClipboardCheck,
  AlertCircle,
  HardHat,
  Calendar,
  FolderOpen,
  Files,
  // FileCheck,
  FileText,
  Users,
  Info,
  ListChecks,
  Activity,
  BarChart3,
  Database,
  Boxes,
} from "lucide-react";

import { hasProjectTabAccess } from "../../constants/projectRoles";

const PROJECT_TABS = [
  { id: "dashboard", label: "Dashboard", icon: LayoutDashboard },
  { id: "info", label: "Project Info", icon: Info },
  { id: "operations-performance", label: "Operations Performance", icon: BarChart3 },
  { id: "engineering-issues", label: "Engineering Issues", icon: Activity },
  { id: "inspections", label: "Inspections", icon: ClipboardCheck },
  { id: "equipment", label: "Equipment", icon: Boxes },
  { id: "issues-control", label: "Issues Control", icon: HardHat },
  { id: "my-issues", label: "My Issues", icon: AlertCircle },
  // { id: "assigned-findings", label: "Assigned Findings", icon: AlertCircle },
  {
    id: "assigned-inspections",
    label: "Assigned Inspections",
    icon: ClipboardCheck,
  },
  { id: "walk-scheduler", label: "Walk Scheduler", icon: Calendar },
  {
    id: "inspection-templates",
    label: "Inspection Templates Design",
    icon: ListChecks,
  },
  { id: "ncr", label: "NCRs", icon: AlertCircle },
  // { id: "safety", label: "Safety", icon: HardHat },
  { id: "daily", label: "Report", icon: FileText },
  { id: "documents", label: "Document Control", icon: FolderOpen },
  { id: "pdf-splitter", label: "PDF Splitter", icon: Files },
  { id: "kb-intake", label: "KB Intake", icon: Database },
  // { id: "photos", label: "Photos", icon: Camera },
  // { id: "materials", label: "Materials", icon: FileCheck },
  { id: "team", label: "Team", icon: Users },
];

const ProjectNavigation = ({
  systemRole,
  projectRole,
  activeProject,
  activeTab,
  onTabChange,
}) => {
  if (!activeProject) return null;

  return (
    <nav className="bg-gray-100 border-b border-gray-300">
      <div className="max-w-7xl mx-auto px-6 py-3">
        <div className="mb-3">
          <h3 className="text-lg font-bold text-gray-800">Project Workspace</h3>
          <p className="text-sm text-gray-600">{activeProject.name}</p>
        </div>

        <div className="flex space-x-2 overflow-x-auto">
          {PROJECT_TABS.map((tab) => {
            const allowAssignedFindings =
              tab.id === "assigned-findings" &&
              (systemRole === "user_external" ||
                projectRole === "client" ||
                projectRole === "foreman" ||
                projectRole === "contractor");

            const allowAssignedInspections =
              tab.id === "assigned-inspections" &&
              systemRole === "user_external" &&
              (projectRole === "client" || projectRole === "contractor");

            const allowMyIssues =
              tab.id === "my-issues" &&
              projectRole !== "operations_manager" &&
              (systemRole === "admin" ||
                systemRole === "user_external" ||
                projectRole === "client" ||
                projectRole === "foreman" ||
                projectRole === "contractor" ||
                projectRole === "supervisor" ||
                projectRole === "general_foreman");

            const allowWalkScheduler =
              tab.id === "walk-scheduler" &&
              (systemRole === "user_external" ||
                projectRole === "client" ||
                projectRole === "foreman" ||
                projectRole === "contractor" ||
                projectRole === "inspector" ||
                projectRole === "qa_qc_manager" ||
                projectRole === "project_manager" ||
                projectRole === "supervisor" ||
                projectRole === "general_foreman");

            const allowForemanControl =
              tab.id === "issues-control" &&
              (projectRole === "supervisor" ||
                projectRole === "general_foreman" ||
                projectRole === "inspector" ||
                projectRole === "qa_qc_manager" ||
                projectRole === "project_manager" ||
                systemRole === "admin");

            const allowReports =
              tab.id === "daily" &&
              (systemRole === "admin" ||
                projectRole === "project_manager" ||
                projectRole === "qa_qc_manager" ||
                projectRole === "inspector" ||
                projectRole === "supervisor" ||
                projectRole === "general_foreman" ||
                hasProjectTabAccess({
                  systemRole,
                  projectRole,
                  tabId: "daily",
                }));

            const hideForExternal =
              (systemRole === "user_external" && tab.id === "photos") ||
              (systemRole === "user_external" && tab.id === "inspections");

            const hideDuplicateOperationsPerformance =
              projectRole === "operations_manager" && tab.id === "operations-performance";

            if (
              hideForExternal ||
              hideDuplicateOperationsPerformance ||
              (!allowAssignedFindings &&
                !allowAssignedInspections &&
                !allowMyIssues &&
                !allowWalkScheduler &&
                !allowForemanControl &&
                !allowReports &&
                !hasProjectTabAccess({
                  systemRole,
                  projectRole,
                  tabId: tab.id,
                }))
            ) {
              return null;
            }

            const Icon = tab.icon;
            const isActive = activeTab === tab.id;

            return (
              <button
                key={tab.id}
                onClick={() => onTabChange(tab.id)}
                className={`flex items-center space-x-2 px-4 py-2 rounded-md text-sm font-medium transition ${
                  isActive
                    ? "bg-orange-500 text-white"
                    : "bg-white text-gray-700 hover:bg-gray-200"
                }`}
              >
                <Icon className="w-4 h-4" />
                <span>{tab.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default ProjectNavigation;
